// removed by extract-text-webpack-plugin
module.exports = {"header":"ch_bg","heading":"ch_i"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/OrganiserDetail/styles.module.css
// module id = 1349
// module chunks = 27